const activateAbSiv016 = () => {
    document.body.setAttribute('data-ab-siv-016', '');
};

// document.addEventListener('DOMContentLoaded', activateAbSiv016);
